import type { PriorityLevel } from './priority.js';
import { PRIORITY_LEVELS } from './priority.js';
import { NormalGlyph, HighGlyph, ExtremeGlyph } from './PriorityGlyphs.js';

// Read-only chip wearing the same tones as the DetailPanel's priority
// selector button — for surfaces that display the priority without editing
// it (e.g. the completion card). Unlike PriorityPill, Normal renders too.
const CHIP_TONES: Record<PriorityLevel, string> = {
    normal: 'border-gray-200 bg-white text-gray-600',
    high: 'border-amber-200 bg-amber-50 text-amber-700',
    extreme: 'border-red-600 bg-red-600 text-white'
};

export function PriorityChip({ priority }: { priority: PriorityLevel }) {
    return (
        <span
            className={`border rounded-lg px-2.5 py-1.5 inline-flex items-center gap-1.5 text-[12.5px] ${
                priority === 'normal' ? '' : 'font-semibold'
            } ${CHIP_TONES[priority]}`}
        >
            {priority === 'normal' && <NormalGlyph className="text-gray-400" />}
            {priority === 'high' && <HighGlyph className="text-amber-500" />}
            {priority === 'extreme' && <ExtremeGlyph className="text-white" />}
            {PRIORITY_LEVELS[priority].label}
        </span>
    );
}
